import React, { useCallback, useEffect, useRef } from "react"
import AvailableToLink from "../../components/DMAutomation/AvailableToLink"
import { useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../redux-stores/store"
import { useDispatch } from "react-redux"
import { fetchAvailablePostsThunk, fetchDMAutomations, setSelectedSocialAccount } from "../../redux-stores/slices/dmAutomationsListSlice"
import { INIT_IG_AUTH_ROUTE, TAGLINKS_DEMO_VIDEO_URL, TAGLINKS_ROCKET_IMG } from "../../constants/constants"
import smartLinksTopImg from "../../assets/images/home/smart-links-top.png"
import smartLinksBottomImg from "../../assets/images/home/smart-links-bottom.png"
import AllLinkedPosts from "../../components/DMAutomation/AllLinkedPosts"
import { Link } from "react-router-dom"
import IGAccountSelector from "../../components/account/IGAccountSelector"
import "./style.scss"
import { markExpired, setLoading } from "../../redux-stores/slices/influencerContentSlice"
import { fetchLatestInfluencerSocialPosts } from "../../services/api/influencer"
import { getErrorMessage } from "../../utils/helpers"
import { toast } from "react-toastify"
const SmartLinks = () => {



    const videoRef = useRef<HTMLVideoElement>(null);


    const selectedSocialAccount = useSelector((state: RootState) => state.dmAutomationsList.selectedSocialAccount);
    const connectionRequired = !selectedSocialAccount || selectedSocialAccount.status !== 'connected';

    const igSocialAccounts = useSelector((state: RootState) => state.influencer.social_accounts?.filter(account => account.social_account.platform === 'ig'));

    const dispatch = useDispatch<AppDispatch>();

    const dmAutomationsData = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!])
    const dmAutomations = dmAutomationsData?.items || [];
    const cta_url = dmAutomationsData?.cta_url || null;

    const loading = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!]?.loading);

    const fetchAutomations = useCallback(async (pageNumber: number, force = false) => {
        if (!selectedSocialAccount) return;
        dispatch(fetchDMAutomations({ socialAccountId: selectedSocialAccount?.social_account?.uuid!, page: pageNumber, force }))
    }, [dispatch, selectedSocialAccount])


    useEffect(() => {
        fetchAutomations(1);
    }, [fetchAutomations, selectedSocialAccount])

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.play().catch(err => console.log("Autoplay failed:", err));
        }
    }, []);



    const fetchAvailablePosts = useCallback(async (force = false) => {
        if (!selectedSocialAccount) return;
        dispatch(fetchAvailablePostsThunk({ socialAccountId: selectedSocialAccount.social_account?.uuid, force }));
    }, [dispatch, selectedSocialAccount])


    const fetchLatestMedia = async (): Promise<void> => {
        if (!selectedSocialAccount) return;
        try {
            dispatch(setLoading(true));
            await fetchLatestInfluencerSocialPosts(selectedSocialAccount.social_account?.uuid);
        } catch (error: any) {
            console.log(error);
            toast.error(getErrorMessage(error));
        } finally {
            dispatch(markExpired());
            fetchAvailablePosts(true);
        }
    }

  

    return (
        <React.Fragment>
            <React.Fragment>
                <div className="smart-links-header"></div>
                <div className="smart-links-demo-card mb-4">
                    <div className="text-center">
                        <video ref={videoRef} src={TAGLINKS_DEMO_VIDEO_URL} muted={true} autoPlay={true} playsInline={true} loop={true} preload="auto"
                            className="w-100"></video>
                    </div>
                </div>
                <div className="smart-links-header-hero mb-3">
                    <span className="hero-sub-text">Your links just got</span>
                    <span className="hero-stylish-text mt-n2">Smarter</span>
                    <span className="fs-14 fw-400 text-muted w-50 text-center">Share links, engage, and close sales automatically.</span>

                </div>
                {
                    cta_url &&
                    <div className="position-relative mt-n4">
                        <div className="d-flex align-items-center justify-content-center position-relative" style={{ height: '108px' }}>
                            <img src={smartLinksTopImg} height={108} className="rounded-sm object-fit-contain position-absolute top-0 start-0" alt="" />
                            <div className="">
                                <svg width="84" height="14" viewBox="0 0 84 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="6.75009" x2="30" y2="6.75009" stroke="#737373" stroke-width="0.5" />
                                    <path d="M47.1899 7.4876C44.8965 8.1051 43.1051 9.89652 42.4876 12.1899L42.0002 14.0002L41.5128 12.1899C40.8951 9.89652 39.1037 8.1051 36.8103 7.4876L35 7.0002L36.8103 6.5128C39.1037 5.8951 40.8951 4.10367 41.5126 1.81033L42 0L42.4874 1.81033C43.1049 4.10367 44.8963 5.8951 47.1897 6.5126L49 7L47.1899 7.4876Z" fill="#737373" />
                                    <line x1="54" y1="6.75009" x2="84" y2="6.75009" stroke="#737373" stroke-width="0.5" />
                                </svg>
                            </div>
                        </div>
                        <div className="app-card p-3 pe-0 mx-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column px-2">
                                    <h4>See how this feature works</h4>
                                    <span>Checkout our instagram post and comment “wow” to explore this incredible feature!</span>
                                    <a href={cta_url} target="_blank" rel='noreferrer' className="btn btn-primary btn-sm w-100 rounded-4 mt-3">Go to Instagram</a>
                                </div>
                                <div className="img">
                                    <img src={TAGLINKS_ROCKET_IMG} height={200} className="rounded-sm object-fit-contain" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center position-relative" style={{ height: '108px' }}>
                            <img src={smartLinksBottomImg} height={108} className="rounded-sm object-fit-contain position-absolute bottom-0 end-0" alt="" />
                            <div className="">
                                <svg width="84" height="14" viewBox="0 0 84 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="6.75009" x2="30" y2="6.75009" stroke="#737373" stroke-width="0.5" />
                                    <path d="M47.1899 7.4876C44.8965 8.1051 43.1051 9.89652 42.4876 12.1899L42.0002 14.0002L41.5128 12.1899C40.8951 9.89652 39.1037 8.1051 36.8103 7.4876L35 7.0002L36.8103 6.5128C39.1037 5.8951 40.8951 4.10367 41.5126 1.81033L42 0L42.4874 1.81033C43.1049 4.10367 44.8963 5.8951 47.1897 6.5126L49 7L47.1899 7.4876Z" fill="#737373" />
                                    <line x1="54" y1="6.75009" x2="84" y2="6.75009" stroke="#737373" stroke-width="0.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
            {
                !loading &&
                <AvailableToLink />
            }
            {
                !loading && !connectionRequired &&
                <React.Fragment>
                    <AllLinkedPosts dmAutomations={dmAutomations} />
                </React.Fragment>
            }
            {
                !loading && connectionRequired &&
                <div className="card card-style">
                    <div className="card-body">
                        <div className="px-2">
                            <h3 className="text-dark">
                                Connect with Instagram to use Smart Links
                            </h3>
                            <p>To start using Smart Links, please connect with your Instagram account first.</p>
                            <Link to={`${INIT_IG_AUTH_ROUTE}?feature=dm-automation`} className="btn btn-sm btn-primary rounded-4">Connect with Instagram</Link>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}


export default SmartLinks